<template>
  <div>
    <NavBar v-if="showNavBar" />
    <router-view />
    <Footer v-if="showFooter" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'app',
  components: {
    NavBar,
    Footer
  },
  computed: {
    ...mapState(['showNavBar', 'showFooter'])
  },
  mounted () {
    // Si el usuario ya se encontraba logueado y el token no expiró, marca como iniciada la sesión
    if (this.$apiService.isAuthenticated() && !this.$apiService.isTokenExpired()) { this.loginUser() }
  },
  methods: {
    ...mapMutations(['loginUser'])
  }
}
</script>

// CUSTOMIZACION BULMA, PARA ACTIVAR DESCOMENTAR AQUI Y COMENTAR EN main.js LA LINEA import 'buefy/dist/buefy.css'
<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$pink: #FF597D;
$secundary: $pink;
$secundary-invert: findColorInvert($secundary);
$primary: #00CEDB;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);
$success: #7FD96A;
$success-invert: findColorInvert($success);
$danger: #FF151F;
$danger-invert: findColorInvert($danger);
$warning: #FFCC53;
$warning-invert: findColorInvert($warning);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "secundary": (
    $secundary,
    $secundary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
@import "~bulma-divider/dist/css/bulma-divider.min.css";
@import "~bulma-divider/dist/css/bulma-divider.sass";
@import '../node_modules/nprogress/nprogress.css';

// Padding para section
.section {
  padding: 2rem 0.5rem;
}

// Customizacion de is-divider
.is-divider {
  margin: 0.2rem 0;
}

// Customizacion de npogress bar
#nprogress .bar {
  background: $primary !important;
}

.is-secundary {
  color: $pink
}

</style>
